export function getMockUrl(url: string) {
    const origin = window.origin.includes('dev.premicorr.net')
        ? 'dev-api.premicorr.net/api'
        : window.origin.includes('demo')
            ? 'demo-api.premicorr.net/api'
            : 'localhost:5000';

    return `https://${origin}${url}`;
}
